import { ThemeTypeDark, ThemeTypeLight } from './types';

export const THEME_TYPE_DARK: ThemeTypeDark = 'dark';
export const THEME_TYPE_LIGHT: ThemeTypeLight = 'light';
